(function () {
    //const productId = productId;

    if (productId !== 10669776011448 &&
        productId !== 10680278286520 &&
        productId !== 10682544947384) {
        return;
    }

    const COOKIE_NAME = "_ex_user";
    const BUTTON_DELAY = 500;
    const BUTTON_LABEL = "Buy Now";
    const GOOGLE_TAG_AND_LABEL = 'AW-18517322294/XiNhCJycuaIdELbU3_1E';

    var PRODUCT_URL = "";

    switch (productId) {
        case 10669776011448:
            PRODUCT_URL = getBLGCartUrl();
            break;
        case 10680278286520:
            PRODUCT_URL = getBBCartUrl();
            break;
        case 10682544947384:
            PRODUCT_URL = getPPCartUrl();
            break;
        default:
            PRODUCT_URL = getBLGCartUrl();
    }

    // function getHBCartUrl() {
    //     const urls = [
    //         "https://www.primesavingslink.com/DLSBD7L/J7HQGBF/?sub1=ex",
    //         "https://nmttrack.com/?a=90187&c=438134&co=121479&mt=4&s1=ex"
    //     ];
    //     return urls[Math.floor(Math.random() * urls.length)];
    // }

    function getPPCartUrl() {
        return "https://cehex.shop/carturl/pprotect";
    }

    function getBBCartUrl() {
        return "https://cehex.shop/carturl/bladderbalance";
    }
    
    function getBLGCartUrl() {
        return "https://cehex.shop/carturl/bluelumeglasses";
    }

    function proceedToCheckout() {
        try {
            window.location.href = PRODUCT_URL;
        } catch (error) {
            try {
                window.top.location.href = PRODUCT_URL;
            } catch (e) {}
        }
    }

    function sendGoogleAdsConversionEvent() {
        try {
            gtag("event", "conversion", {
                send_to: GOOGLE_TAG_AND_LABEL
            })
        } catch (e) {}
    }

    function setCustomCookie(name, value, days) {
        try {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            const expires = "expires=" + date.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/;Secure;SameSite=Strict";
        } catch (error) {}
    }

    function getCustomCookie(name) {
        try {
            const nameEQ = name + "=";
            const cookies = document.cookie.split(';');
            for (var cookie of cookies) {
                while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
                if (cookie.indexOf(nameEQ) === 0) return cookie.substring(nameEQ.length);
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    function extractParams(url) {
        const params = {};
        const query = (url ? new URL(url) : window.location).search.slice(1);
        query.split("&").forEach(param => {
            const [key, value] = param.split("=");
            if (key) params[decodeURIComponent(key)] = decodeURIComponent(value || "");
        });
        return params;
    }

    function getAdditionalDescription(productId) {
        var description = '';
        switch (productId) {
            case 10669776011448:
                description = `<div style="max-width: 720px; margin: 0 auto; padding: 25px 10px; color: #1a1a1a; line-height: 1.7;"><div style="background: #fef2e8; color: #c2410c; text-align: center; padding: 10px; border-radius: 40px; font-weight: 700; font-size: 13px; margin-bottom: 20px;">🔥 50% OFF — TODAY ONLY — FAST SHIPPING 🔥</div><p style="font-size: 17px; margin-bottom: 20px;">Tired of juggling readers, distance glasses, and sunglasses all day? <strong>BlueLume Glasses</strong> combine all three into <strong>one lightweight pair</strong> — under one ounce. See near to far with adaptive lenses, get built-in blue light filtering for screens, and let photochromic lenses darken automatically in sunlight. No swapping pairs. No bag full of cases. Just one pair that keeps up with your day.</p><ul style="list-style: none; padding: 0; margin: 0 0 18px 0;"><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>“I got rid of my other glasses!”</strong> — James R., Verified Customer</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Near-to-Far Lenses</strong> — Read your phone, check road signs, same pair</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Auto-Darkening Outdoors</strong> — Photochromic lenses = sunglasses built in</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Built-In Blue Light Filter</strong> — Less screen-related eye fatigue</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Under 1 Ounce</strong> — Comfortable all-day wear</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>90-Day Money-Back Guarantee</strong> — Full refund if not satisfied</li></ul><div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 20px; margin: 20px 0; padding: 15px 0; border-top: 1px solid #e5e7eb; border-bottom: 1px solid #e5e7eb;"><div style="text-align: center; font-size: 13px;">⭐ 4.8/5 (27,392+ Customers)</div><div style="text-align: center; font-size: 13px;">🚚 Fast Shipping</div><div style="text-align: center; font-size: 13px;">🔒 90-Day Guarantee</div></div><div style="background: #f0fdf4; padding: 16px; border-radius: 12px; margin: 20px 0; border: 2px solid #15803d; text-align: center;"><p style="margin: 0; font-size: 16px; font-weight: bold; color: #15803d;">🔥 50% OFF — TODAY ONLY</p><p style="margin: 4px 0 0 0; font-size: 14px; color: #333;">Fast Shipping • 90-Day Money-Back Guarantee • No Prescription Needed</p></div><p style="text-align: center; font-size: 0.95em; color: #444; margin: 0 0 10px 0;"><strong>Why settle for three pairs?</strong> Reading up close, seeing farther away, bright outdoor light, screen use — one pair covers it all.</p><div style="text-align: center; margin-top: 20px; padding: 18px; background: #fff3f3; border: 2px dashed #d90429; border-radius: 10px;"><p style="font-size: 1.2em; font-weight: bold; color: #d90429; margin: 0 0 4px 0;">🚀 90-Day Money-Back Guarantee + Fast Shipping</p><p style="font-size: 0.85em; color: #777; margin: 0;">Fast dispatch • Tracking included • Risk-Free</p></div><div style="text-align: center; margin-top: 16px; padding: 10px; background: #f0fdf4; border-radius: 8px;"><p style="font-size: 13px; font-weight: bold; color: #15803d; margin: 0;">👉 To claim your discount, click the <strong style="background: #d90429; color: white; padding: 3px 10px; border-radius: 20px;">Buy Now</strong> button above 👆</p></div></div>`;
                break;
            case 10680278286520:
                description = `<div style="max-width: 720px; margin: 0 auto; padding: 25px 10px; color: #1a1a1a; line-height: 1.7;"><div style="background: #fef2e8; color: #c2410c; text-align: center; padding: 10px; border-radius: 40px; font-weight: 700; font-size: 13px; margin-bottom: 20px;">🔥 BUY 3 GET 3 FREE — FREE SHIPPING IN US 🔥</div><p style="font-size: 17px; margin-bottom: 20px;">Tired of planning your day around bathroom breaks? The urgency, the frequency, the leaks — it's exhausting. <strong>Bladder Balance Capsules</strong> are designed to support healthy bladder function and urinary tract comfort. A simple daily capsule that works with your body to help you feel more in control again. No harsh prescriptions. No awkward conversations. Just support for your daily comfort.</p><ul style="list-style: none; padding: 0; margin: 0 0 18px 0;"><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Supports Healthy Bladder Function</strong> — Daily support for urinary comfort</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Helps Reduce Urgency & Frequency</strong> — Feel more in control</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Supports a Healthy Urinary Tract</strong> — Botanical blend for daily wellness</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Convenient Capsule Format</strong> — Simple daily routine</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>30-Day Money-Back Guarantee</strong> — Try it risk-free</li></ul><div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 20px; margin: 20px 0; padding: 15px 0; border-top: 1px solid #e5e7eb; border-bottom: 1px solid #e5e7eb;"><div style="text-align: center; font-size: 13px;">🇺🇸 US Residents Only</div><div style="text-align: center; font-size: 13px;">🚚 Free US Shipping</div><div style="text-align: center; font-size: 13px;">🔒 30-Day Guarantee</div></div><div style="background: #f0fdf4; padding: 16px; border-radius: 12px; margin: 20px 0; border: 2px solid #15803d; text-align: center;"><p style="margin: 0; font-size: 16px; font-weight: bold; color: #15803d;">🔥 BEST VALUE — BUY 3, GET 3 FREE</p><p style="margin: 4px 0 0 0; font-size: 14px; color: #333;">Free Shipping • 30-Day Guarantee • 6 Months Supply</p></div><p style="text-align: center; font-size: 0.95em; color: #444; margin: 0 0 10px 0;"><strong>Stock is limited.</strong> Due to high demand, availability is low. Secure your order before it sells out.</p><div style="text-align: center; margin-top: 20px; padding: 18px; background: #fff3f3; border: 2px dashed #d90429; border-radius: 10px;"><p style="font-size: 1.2em; font-weight: bold; color: #d90429; margin: 0 0 4px 0;">🚀 30-Day Money-Back Guarantee + Free US Shipping</p><p style="font-size: 0.85em; color: #777; margin: 0;">🇺🇸 Fast & Free Shipping • Limited Stock • Risk-Free</p></div><div style="text-align: center; margin-top: 16px; padding: 10px; background: #f0fdf4; border-radius: 8px;"><p style="font-size: 13px; font-weight: bold; color: #15803d; margin: 0;">👉 To claim your discount, click the <strong style="background: #d90429; color: white; padding: 3px 10px; border-radius: 20px;">Buy Now</strong> button above 👆</p></div></div>`;
                break;
            case 10682544947384:
                description = `<div style="max-width: 720px; margin: 0 auto; padding: 25px 10px; color: #1a1a1a; line-height: 1.7;"><div style="background: #fef2e8; color: #c2410c; text-align: center; padding: 10px; border-radius: 40px; font-weight: 700; font-size: 13px; margin-bottom: 20px;">🔥 LIMITED TIME — FREE US SHIPPING 🔥</div><p style="font-size: 17px; margin-bottom: 20px;">Tired of counting capsules and remembering pills every day? <strong>P-Protect Patch</strong> is a transdermal men's wellness patch designed for <strong>prostate wellness, urinary comfort, circulation, and everyday vitality</strong>. Just apply one discreet patch and go about your day — no pills, no water, no hassle. Each monthly pack contains <strong>10 patches</strong>, and with multiple package options, it's a simple addition to your daily routine.</p><ul style="list-style: none; padding: 0; margin: 0 0 18px 0;"><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>“Switching to a patch format was a game-changer for my routine.”</strong> — Verified Customer</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Supports Prostate Wellness</strong> — Daily support for men's health</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Supports Urinary Comfort</strong> — Feel more in control</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Supports Healthy Circulation</strong> — Transdermal delivery</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>Supports Everyday Vitality</strong> — Energy and daily balance</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>10 Patches Per Pack</strong> — 30-day supply per pack</li><li style="margin-bottom: 10px; padding-left: 4px;">🔥 <strong>60-Day Money-Back Guarantee</strong> — Full refund, no questions asked</li></ul><div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 20px; margin: 20px 0; padding: 15px 0; border-top: 1px solid #e5e7eb; border-bottom: 1px solid #e5e7eb;"><div style="text-align: center; font-size: 13px;">🇺🇸 US Residents Only</div><div style="text-align: center; font-size: 13px;">🚚 Free US Shipping</div><div style="text-align: center; font-size: 13px;">🔒 60-Day Guarantee</div></div><div style="background: #f0fdf4; padding: 16px; border-radius: 12px; margin: 20px 0; border: 2px solid #15803d; text-align: center;"><p style="margin: 0; font-size: 16px; font-weight: bold; color: #15803d;">🔥 LIMITED TIME OFFER</p><p style="margin: 4px 0 0 0; font-size: 14px; color: #333;">Free US Shipping • 60-Day Money-Back Guarantee</p></div><p style="text-align: center; font-size: 0.95em; color: #444; margin: 0 0 10px 0;">Join American men who are simplifying their daily wellness routine.</p><div style="text-align: center; margin-top: 20px; padding: 18px; background: #fff3f3; border: 2px dashed #d90429; border-radius: 10px;"><p style="font-size: 1.2em; font-weight: bold; color: #d90429; margin: 0 0 4px 0;">🚀 60-Day Money-Back Guarantee + Free US Shipping</p><p style="font-size: 0.85em; color: #777; margin: 0;">🇺🇸 Fast & Free Shipping • Limited Stock • Risk-Free</p></div><div style="text-align: center; margin-top: 16px; padding: 10px; background: #f0fdf4; border-radius: 8px;"><p style="font-size: 13px; font-weight: bold; color: #15803d; margin: 0;">👉 To claim your discount, click the <strong style="background: #d90429; color: white; padding: 3px 10px; border-radius: 20px;">Buy Now</strong> button above 👆</p></div></div>`;
                break;
            default:
                description = "<p></p>";
                break;
        }
        return description;
    }

    function addDescription(productId) {
        const descriptionContent = getAdditionalDescription(productId);

        if (!descriptionContent || descriptionContent.trim() === "" || descriptionContent.trim() === "<p></p>") {
            return;
        }

        const newBlock = `<div class="extra-product-description">${descriptionContent}</div>`;

        const originalDesc = document.querySelector(".product-single__description .product-description");

        if (originalDesc) {
            originalDesc.insertAdjacentHTML("beforebegin", newBlock);
            return;
        }

        const fallbackDesc = document.querySelector(".product-single__description.rte");

        if (fallbackDesc) {
            fallbackDesc.insertAdjacentHTML("beforebegin", newBlock);
            return;
        }

        const formElement = document.querySelector("form[action='/cart/add']");
        const customButton = document.getElementById("custom_tracker_btn");

        if (formElement) {
            formElement.insertAdjacentHTML("afterend", newBlock);
        } else if (customButton) {
            customButton.insertAdjacentHTML("afterend", newBlock);
        }
    }

    function createCustomButton() {
        const customButton = document.createElement("button");
        customButton.id = "custom_tracker_btn";
        customButton.type = "button";
        customButton.style.display = "none";
        customButton.className = "btn";
        customButton.innerHTML = '<span id="custom_tracker_btn_span">Buy Now</span>';

        const productForm = document.querySelector("form[action='/cart/add']");
        if (productForm) {
            productForm.appendChild(customButton);
        }

        customButton.addEventListener("click", () => {
            sendGoogleAdsConversionEvent();
            proceedToCheckout();
        });

        return customButton;
    }

    function updateButton() {
        const originalButton = document.querySelector("form[action='/cart/add'] [type='submit']") ||
            document.querySelector("#add-to-cart") ||
            document.querySelector("#product-add-to-cart");

        var customButton = document.getElementById("custom_tracker_btn");

        if (!customButton) {
            customButton = createCustomButton();
        }

        if (originalButton && customButton) {
            customButton.className = originalButton.className;
            customButton.style.display = "block";
            customButton.textContent = BUTTON_LABEL;
            originalButton.style.display = "none";

            if (window.MutationObserver) {
                const observer = new MutationObserver(() => {
                    originalButton.style.display = "none";
                    customButton.style.display = "block";
                });

                const config = {
                    childList: true,
                    subtree: true
                };
                observer.observe(customButton.parentNode, config);
            } else {
                setInterval(() => {
                    originalButton.style.display = "none";
                    customButton.style.display = "block";
                }, 4000);
            }
        }
    }

    function startProcess() {
        setTimeout(() => {
            updateButton();
            try {
                addDescription(productId);
            } catch (e) {}
        }, BUTTON_DELAY);
    }

    function initialize() {
        try {
            const paramData = extractParams();
            const paramKey = "via";
            const hasParam = paramKey in paramData;
            const paramValue = paramData[paramKey];

            if (hasParam && paramValue.trim() !== "") {
                setCustomCookie(COOKIE_NAME, paramValue, 30);
            }

            const isParamActive = !!getCustomCookie(COOKIE_NAME) || hasParam;

            if (isParamActive) {
                startProcess();
            }
        } catch (error) {
            startProcess();
        }
    }

    document.addEventListener("DOMContentLoaded", () => {
        initialize();
    });
})();